module.exports = __webpack_public_path__ + "static/nacw-0d3619f464647971ed0059f8c672c6b4.jpg";